module.exports = __webpack_public_path__ + "img/float-video-on.99fb527b.svg";